import React from 'react'
import { Copy, Visible } from 'components/icons'
import Menu, { MenuProps } from 'components/menu'
import { useDataContext } from 'components/spreadsheet/contexts/data/useDataContext'
import { getAllGroupRows } from 'components/spreadsheet/helpers/grouping'

const GroupContextMenu: React.FC<MenuProps> = ({ id, menuState, setMenuState, width }) => {
  const { spreadsheetData, setSpreadsheetData, groupedRows, copyGroupCellValue } = useDataContext()
  const { columnId, groupKey, rowId } = menuState
  const canCopyValue = !!columnId && !!groupKey && !!rowId

  const handleCopyValue = (): void => {
    if (!columnId || !groupKey || !rowId) return

    copyGroupCellValue({ columnId, groupKey, rowId })
    setMenuState({ ...menuState, open: false })
  }

  const handleToggle = () => {
    if (groupedRows && menuState.columnId !== undefined) {
      // When toggling column collapse, use all visible rows
      setSpreadsheetData({
        type: 'TOGGLE_COLUMN_COLLAPSE',
        columnId: menuState.columnId,
        rows: getAllGroupRows(groupedRows)
      })
      setMenuState({ ...menuState, open: false })
    }
  }

  const label =
    spreadsheetData.collapsedColumnIds.size > 0 &&
    menuState.columnId !== undefined &&
    spreadsheetData.collapsedColumnIds.has(menuState.columnId)
      ? 'Expand column'
      : 'Collapse column'

  return (
    <Menu id={id} menuState={menuState} setMenuState={setMenuState} width={width}>
      <div className="p-0 m-2.5 list-none">
        {canCopyValue && (
          <li>
            <div
              className="relative flex items-center rounded text-body select-none transition-all truncate cursor-pointer hover:bg-surface-sunken h-8 leading-[32px] py-0 px-2.5"
              data-testid="group-menu-copy-value"
              onClick={handleCopyValue}
            >
              <Copy /> <span className="ml-2.5">Copy value</span>
            </div>
          </li>
        )}
        <li>
          <div
            className="relative flex items-center rounded text-body select-none transition-all truncate cursor-pointer hover:bg-surface-sunken h-8 leading-[32px] py-0 px-2.5"
            onClick={handleToggle}
          >
            <Visible /> <span className="ml-2.5">{label}</span>
          </div>
        </li>
      </div>
    </Menu>
  )
}

export default GroupContextMenu
